export default __webpack_public_path__ + "static/media/logo.b23ead3f.svg";